import type { KambiListView } from '@mobi/api-types/kambi'
import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'

export function getEventsForLeague(
  sport: string,
  region: string,
  league: string,
  participants: string,
  includeParticipants = false
) {
  const query = `?lang=en_AU&market=AU&useCombined=true&useCombinedLive=true&includeParticipants=${includeParticipants}`
  return simpleFetch<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/${sport}/${region}/${league}/${participants}/matches${query}`
  )
}

export function getFuturesEventsForCompetition(sport: string, region: string, league: string) {
  return simpleFetch<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/${sport}/${region}/${league}/all/competitions?lang=en_AU&market=AU`
  )
}
